import type { Listing } from 'app/types/listing';
import { ListingType } from 'app/types/listing';
import type { UserLevelType } from 'app/schemas/user';
import { UserLevel } from 'app/schemas/user';
import type { User } from 'app/types/user';

export const HAS_DOWNLOADED_APP_META_NAME = 'has_downloaded_app';

export const hasDownloadedApp = (user?: User | null) =>
  Boolean(
    user?.metas?.some(
      (meta) => meta.name === HAS_DOWNLOADED_APP_META_NAME && (meta.value === true || meta.value === 'true'),
    ),
  );

export const isLender = (userId?: User['id'], listingUserId?: Listing['userId'], listingType?: ListingType) =>
  (userId === listingUserId && listingType === ListingType.offer) ||
  (userId !== listingUserId && listingType === ListingType.request);

export const getLevelNumber = (level?: UserLevelType) => {
  if (!level) {
    return 0;
  }
  const levels = Object.values(UserLevel);
  return levels.indexOf(level);
};
